// src/features/account/api/editAvatar.js
import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const editAvatar = (formData) => {
  return axios.post('/users/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const useEditAvatar = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: editAvatar,
    onSuccess: () => {
      queryClient.invalidateQueries('user');
      addNotification({
        type: 'success',
        title: 'Avatar updated',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Avatar upload failed',
        message: 'Please try again or check your connection.',
      });
    },
    ...config,
  });
};
